import React, { lazy } from 'react';
export function SolutionSection() {
  return <section className="bg-bb-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        <div className="text-center mb-12" data-id="element-211">
          <div className="bg-bb-charcoal text-bb-cream font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-212">
            The Official 6-in-1 Elite Coaching System
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-4 tracking-tight" data-id="element-213">
            Engineered for dedicated{' '}
            <span className="text-bb-orange" data-id="element-214">coaching professionals</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-215">
          <div className="relative" data-id="element-216">
            <div className="absolute -inset-4 bg-bb-orange/15 rounded-3xl blur-2xl pointer-events-none" data-id="element-217"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dWteTQevNEHvKbLzQXkEmc/heylloyd-image-1780160765114.webp" alt="The Basketball Coach's Bible Box Set" className="w-full rounded-2xl shadow-xl relative" loading="lazy" decoding="async" width="800" height="800" data-id="element-218" />
          </div>

          <div data-id="element-219">
            <p className="text-bb-slate text-base leading-relaxed mb-6" data-id="element-220">
              <span className="font-display font-bold uppercase text-bb-charcoal" data-id="element-221">
                The Basketball Coach's Bible
              </span>{' '}
              is more than just a playbook. It's a comprehensive operational
              system that delivers a{' '}
              <span className="font-semibold text-bb-charcoal" data-id="element-222">
                full year of structured tactical roadmaps
              </span>{' '}
              — ensuring elite-level flow and total confidence on the court.
            </p>
            <ul className="space-y-3" data-id="element-223">
              {['365-Day Strategic Tactical Roadmap', 'High-efficiency practice templates (60/90/120 min)', '50 "Secret" Baseline Plays Playbook', 'Parent Communication Toolkit', 'Strength & Agility for Youth Athletes', 'Scouting & Stats Toolkit'].map((item, i) => <li key={i} className="flex items-start gap-3 text-bb-slate" data-id="element-224">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-bb-orange text-white flex items-center justify-center text-xs font-bold mt-0.5" data-id="element-225">
                    {i + 1}
                  </span>
                  <span className="text-base" data-id="element-226">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}